import React from 'react';
import { Link } from 'react-router-dom';
import './Button.css';

const BUTTON_STYLES = {
  PRIMARY: 'btn--primary',
  OUTLINE: 'btn--outline'
};

const BUTTON_SIZES = {
  MEDIUM: 'btn--medium',
  LARGE: 'btn--large'
};

const isValidStyle = (style) => Object.values(BUTTON_STYLES).includes(style);
const isValidSize = (size) => Object.values(BUTTON_SIZES).includes(size);

export const Button = ({ 
  children, 
  type = 'button', 
  onClick, 
  buttonStyle = BUTTON_STYLES.PRIMARY, 
  buttonSize = BUTTON_SIZES.MEDIUM,
  to,
  className = '',
  disabled = false,
  ariaLabel
}) => {

  const validStyle = isValidStyle(buttonStyle) ? buttonStyle : BUTTON_STYLES.PRIMARY;
  const validSize = isValidSize(buttonSize) ? buttonSize : BUTTON_SIZES.MEDIUM;

  const buttonClasses = `btn ${validStyle} ${validSize} ${className}`.trim();
  
  const buttonProps = {
    className: buttonClasses,
    onClick,
    type,
    disabled,
    'aria-label': ariaLabel || (typeof children === 'string' ? children : undefined)
  };

  if (to) {
    return (
      <Link to={to} className="btn-link-wrapper">
        <button {...buttonProps}>
          {children}
        </button>
      </Link>
    );
  }

  return (
    <button {...buttonProps}>
      {children}
    </button>
  );
};

export { BUTTON_STYLES, BUTTON_SIZES };